module.exports = __webpack_public_path__ + "img/D201312_2.246e6572.jpg";